import { createUseStyles } from '../../theme/theming';

const useTextGridStyles = createUseStyles((theme) => ({
  section: {
    background: theme.colors.background1,
    padding: ({ isMobile } = {}) =>
      isMobile
        ? `${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
        : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    },
    '& h2,& h3,& p': {
      marginTop: '0'
    }
  },
  sectionContainer: {
    margin: '0 auto',
    maxWidth: ({ containerWidth } = {}) => containerWidth
  },
  subheading: {
    color: theme?.colors?.font1,
    fontSize: theme.typography.fontSize.subHead,
    lineHeight: '20px',
    letterSpacing: '3px',
    wordBreak: 'break-word',
    textTransform: 'uppercase',
    marginBottom: '8px'
  },
  heading: {
    fontSize: theme.typography.fontSize.h2,
    lineHeight: 'normal',
    fontWeight: theme.typography.fontWeight.bold,
    letterSpacing: '-3px',
    marginBottom: theme.spacing.margin.tiny,
    wordBreak: 'break-word',
    color: theme?.colors?.font1
  },

  sliderContainer: {
    margin: '0 -10px'
  },

  node: {
    margin: '0 16px',
    padding: '48px',
    position: 'relative',
    height: 'calc(100% - 12px)',
    background: theme?.palette?.background?.default,
    boxShadow: theme?.shadows?.primary,
    borderRadius: theme?.shape?.borderRadius?.regular
  },

  nodeTitle: {
    color: theme?.palette?.font.default,
    fontSize: theme.typography.fontSize.h4,
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: 'normal',
    margin: '0 0 20px',
    wordBreak: 'break-word'
  },

  nodePara: {
    color: theme?.palette?.font.tertiary,
    fontSize: theme.typography.fontSize.body,
    lineHeight: '24px',
    wordBreak: 'break-word'
  },

  contentRow: {
    display: 'grid',
    gridTemplateColumns: ({ slidesToShow } = {}) =>
      `repeat(${slidesToShow},minmax(0, 1fr))`
  },

  '@media screen and (max-width: 767px)': {
    sliderContainer: {
      margin: '0 -20px 0 -10px'
    },
    node: {
      padding: '16px',
      margin: '0 6px'
    },
    nodeTitle: {
      fontSize: '20px',
      marginBottom: '0px'
    },
    nodePara: {
      fontSize: '14px',
      display: 'block',
      margin: '16px 0 !important',
      lineHeight: '22px'
    },
    subheading: {
      textAlign: 'center'
    },
    heading: {
      textAlign: 'center',
      letterSpacing: '0'
    }
  }
}));

export default useTextGridStyles;
